import { useState } from "react";
import { api, BASE, SITE_HOST } from "../api";
import { Logo } from "../components/Logo";

// Shown instead of the dashboard until the signed-in customer has accepted the
// current user agreement. The API enforces the same rule (403
// agreement_required on webapps / credits), so this is not just a UI gate.
export function AgreementGate({
  email,
  version,
  onAccepted,
  onLogout,
}: {
  email: string;
  version: string;
  onAccepted: () => void;
  onLogout: () => void;
}) {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function accept() {
    setBusy(true);
    setErr(null);
    try {
      await api.acceptAgreement(version);
      onAccepted();
    } catch (e) {
      const msg = e instanceof Error ? e.message : "";
      // The text changed while this page was open: reload to show the new one.
      if (msg === "agreement_version_mismatch") window.location.reload();
      else setErr("Onay kaydedilemedi. Tekrar deneyin.");
    } finally {
      setBusy(false);
    }
  }

  async function logout() {
    try {
      await api.logout();
    } finally {
      onLogout();
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card" style={{ width: "min(560px, 100%)" }}>
        <div className="login-brand">
          <Logo size={36} title={SITE_HOST} />
          <h1>Kullanıcı Sözleşmesi</h1>
        </div>
        <p className="muted" style={{ marginTop: 0 }}>
          {email} hesabıyla devam etmek için güncel Kullanıcı Sözleşmesi’ni (sürüm {version})
          onaylamanız gerekiyor. Öne çıkan maddeler:
        </p>
        <ul className="muted" style={{ paddingLeft: 18, lineHeight: 1.6 }}>
          <li>
            Hizmet; yasa dışı bahis, kumar, casino ve şans oyunu sitelerinde, erişimi engellenmiş
            sitelerde, dolandırıcılık ve izinsiz finansal faaliyetlerde ve diğer hukuka aykırı
            işlerde <strong>kullanılamaz</strong>.
          </li>
          <li>
            İhlal tespit edilirse veya ciddi şüphe oluşursa hizmet bildirim yapılmadan askıya
            alınabilir, hesap kapatılabilir; kullanılmamış krediler iade edilmez.
          </li>
          <li>
            Hizmet’in kullanıldığı site hakkında bilgi ve belge istenebilir; 3 iş günü içinde
            yanıt verilmesi gerekir.
          </li>
          <li>Gerektiğinde yetkili makamlarla bilgi paylaşılır.</li>
        </ul>
        <p style={{ margin: "8px 0 12px" }}>
          <a href={`${BASE}/kosullar`} target="_blank" rel="noreferrer">
            Sözleşmenin tamamını okuyun →
          </a>
        </p>
        <label className="row" style={{ gap: 8, alignItems: "flex-start", fontSize: 13 }}>
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ width: "auto", flex: "0 0 auto", marginTop: 3 }}
          />
          <span className="muted">
            Kullanıcı Sözleşmesi’ni okudum, anladım ve kabul ediyorum.
          </span>
        </label>
        {err && <div className="error">{err}</div>}
        <div className="row" style={{ gap: 8, marginTop: 16 }}>
          <button type="button" disabled={!checked || busy} onClick={accept}>
            {busy ? "Kaydediliyor…" : "Kabul et ve devam et"}
          </button>
          <button type="button" className="secondary" onClick={logout}>
            Çıkış yap
          </button>
        </div>
      </div>
    </div>
  );
}
